import * as React from 'react';
import { observer } from 'mobx-react';
import { Icon } from 'office-ui-fabric-react/lib/Icon';
import { Label } from 'office-ui-fabric-react/lib/Label';
import { Link } from 'office-ui-fabric-react/lib/Link';
import { PrimaryButton } from 'office-ui-fabric-react/lib/Button';
import { ControlIcons } from 'owa-control-icons';
import strings from 'owa-strings/owa-options-strings';

const styles = require('./ManageAppAccess.scss');

function onLinkedInLearnMoreClicked(): void {
    window.open('https://go.microsoft.com/fwlink/?linkid=850740');
}

function onDisconnectLinkedInClicked(): void {
    window.open('https://account.live.com/consent/LinkedIn');
}

@observer
export default class ManageAppAccess extends React.Component<{}, {}> {
    render() {
        return (
            <div className={styles.appElement}>
                <div className={styles.appDescription}>
                    <Icon iconName={ControlIcons.LinkedInLogo} className={styles.linkedInLogo} />
                    <Label className={styles.linkedInLabel}>
                        {strings.option_app_access_linked_in}
                    </Label>
                    <Link className={styles.linkedInLink} onClick={onLinkedInLearnMoreClicked}>
                        {strings.option_app_access_learn_more_linked_in}
                    </Link>
                </div>
                <PrimaryButton
                    onClick={onDisconnectLinkedInClicked}
                    text={strings.option_app_access_disconnect_linked_in}
                />
            </div>
        );
    }
}
